<script>
  import { onMount } from "svelte";

  import { currentProgress, reachedScrollBottom, spotlightActive } from "../stores/scrollVars.js";
  import mq from "../stores/mq.js"; // here, defined laptop = 992px
  import SceneDetailBorder from "./SceneDetailBorder.svelte";

  export let scenesWithDetails;
  export let currentDetails;
  export let outro = false;

  $: showBook = outro && ($currentProgress > threshold.lastScene || $reachedScrollBottom);

  import cover from "../data/underwater-finalcover.jpg";

  const threshold = {
    lower: 0.1,
    upper: 0.9,
    lastScene: 0.8
  };

  $: {
    if (!$mq.laptop){
      threshold.lower = 0.5;
    } else {
      threshold.lower = 0.1;
    }
  }
  $: {
    if (outro) {
      threshold.lower = 0.45;
      threshold.upper = 1;
    } else {
      threshold.lower = 0.1;
      threshold.upper = 0.9;
    }
  }

  $: isActive =
    $reachedScrollBottom ||
    (currentDetails.length && $currentProgress > threshold.lower && $currentProgress < threshold.upper);

  $: $spotlightActive = isActive;

  $: detailProgress = ($currentProgress - threshold.lower) / (threshold.upper - threshold.lower)
</script>

<div class="scene-details-container {$mq.classNames}" class:active={isActive}>
    {#each scenesWithDetails as d, i}
    <div class="scene-detail-wrapper">
      <div class="scene-detail" class:active={isActive &&
        currentDetails.includes(d.details[0])}>
          {#each d.details as detailImg, j}
          <div
            class="image-wrapper detail {d.backdrop}"
            class:active={isActive &&
              currentDetails.includes(detailImg) &&
              !(outro && $currentProgress > threshold.lastScene)}
          >
            <img
              alt=""
              src={detailImg}
              style="
                opacity: {detailProgress * currentDetails.length < j ? 0 : 1};
              "
              width="800" height="800"
            />
          </div>

          {#if j == 0}
            <SceneDetailBorder 
              active={isActive &&
                currentDetails.includes(d.details[0]) &&
                !(outro && $currentProgress > threshold.lastScene)}
              colour = {d.detailColour[Math.floor(detailProgress * currentDetails.length)]}/>
          {/if}

          {#if i == scenesWithDetails.length - 1 && j == d.details.length - 1}
            <div
              class="outro-scene {$mq.classNames}"
              class:active={isActive && outro}
              class:animate={showBook}
            >
              <div class="image-wrapper book">
                <img alt="" src={cover} />
              </div>

            </div>
          {/if}
          {/each}
        </div>
    </div>
    {/each}
</div>

<style>
  :root {
    --scene-anim: 1s;
    --detail-anim-in: 0.5s;
    --detail-anim-out: 1s;
  }

  .scene-details-container {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    opacity: 0;
    transition: opacity 1s;
    transform: translateZ(0);
    overflow: hidden;
  }

  .scene-details-container.active {
    opacity: 1;
    transition: opacity 0.7s;
  }

  .scene-detail-wrapper {
    width: 100%;
    position: absolute;
    top: 50vh;
    /* top: calc(var(--vh) * 50); */
    left: 50%;
    /* Adjust image so it's centered */
    transform: translate3d(-50%, -50%, 0);
  }

  .scene-detail { 
    transform: scale(0.2) translateZ(0);
    width: max-content;
    max-width: 90vw;
    max-height: 90vh;
    /* max-height: calc(var(--vh, 1vh) * 90); */
    transition: transform 20s ease-in;
    margin: 0 auto;
  }

  .scene-detail.active {
    transform: scale(1) translateZ(0);
    transition: transform 0.2s ease-out;
  }

  .detail {
    opacity: 0;
    transition: opacity var(--detail-anim-out, 1s) ease-in;
    transform: translateZ(0);
  }
  .detail.active {
    opacity: 1;
    transition: all var(--detail-anim-in, 1s);
  }

  .image-wrapper.detail {
    position: absolute;
    top: 0;
    left: 0;
    width: max-content;
  }

  .image-wrapper.detail:first-child {
    /* Important so that the parent has a width */
    position: static;
  }


  .detail img {
    border-radius: 50%;
    /* border: 1px solid var(--border); */
    /* box-shadow: 10px 10px 20px 2px hsla(var(--shadow_hsl), 0.05); h-offset v-offset blur spread color .. 10px 10px 8px 10px var(--purple) */
    object-fit: scale-down;
    /* border-top-left-radius: 52% 48%;
    border-top-right-radius: 48% 52%;
    border-bottom-right-radius: 52% 48%;
    border-bottom-left-radius: 48% 52%; */
    max-width: 90vw;
    max-height: 90vh;
    height: auto;
    width: auto;
    /* max-height: calc(var(--vh, 1vh) * 90); */
    transition: opacity var(--scene-anim, 1s);
    transform: translateZ(0);

  }

  .scene-details-container.mq-laptop .detail img { 
    max-width: 60vw;
    max-height: 80vh;
  }

  .detail.city img{
    transition: opacity 0.2s;
  }

  .detail.active img {
    opacity: 1;
  }

  .outro-scene {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: var(--z-top);
    opacity: 0;
    transition: opacity var(--detail-anim-out, 1s) ease-in;
  }

  .outro-scene.active {
    opacity: 1;
    transition: opacity var(--detail-anim-in, 1s);
  }


  .book img {
    width: 612px;
    height: auto;
    max-height: 80vh;
    /* max-height: calc(var(--vh, 1vh) * 90); */
    max-width: 90vw;
    min-height: var(--minHeight);
    object-fit: contain;
    transform: translate(-50%, -50%);
  }

  .outro-scene .book {
    transform: translate3d(0%, 18%,0) 
      skew(-60deg, 30deg) scale(0.05, 0.035);
    z-index: var(--z-top);
    transition: transform 1s;
    height: 100%;
    width: 100%;
  }

  .outro-scene.animate .book {
    transform: scale(1) translate3d(50%,50%,0) skew(0deg, 0deg);
    transition: transform 1s;
  }


</style>
